import glamorous from 'glamorous';

export default glamorous.h1();


// WEBPACK FOOTER //
// ./lib/components/content/Title.js